import { ResponseError } from '../../../services/api';
import { Config, Data } from '../../../utils/newTableHelper';

export enum ScreenConstructorTypes {
  'LOAD_REQUEST' = '@screenConstructor/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@screenConstructor/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@screenConstructor/LOAD_FAILURE',
}

export interface Pagination {
  current: number;
  total: number;
  pageSize: number;
}

export interface ScreenConstructorState {
  readonly data: Data[];
  readonly config?: Config;
  readonly pagination?: Pagination;
  readonly loading: boolean;
  readonly error?: ResponseError;
} 
